import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ModelService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getModel(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/model/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getActiveModelsOfStockProducts(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/model/stock-product-models/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getModelsOfStockProducts(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/model/stock-product-models/?archive=true&' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getModelItem(modalId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/model/' + modalId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageModel(modal, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/model/' + id, modal)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/model/  ', modal)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setSuppliers(models, supplierId, scope = 'backoffice') {
    return this.http.put<any>(environment.apiUrl + '/' + scope + '/model/supplier/' + supplierId, models)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteModel(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/model/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getModelReplace(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public getModelReplaceForModel(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/model/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/model/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getSuppliers() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/supplier/supplier_items')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdModel(id) {
    return this.http.put(environment.apiUrl + '/backoffice/model/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setParentPosition(productId, position) {
    return this.http.put(environment.apiUrl + '/backoffice/model/product/' + productId + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
